import {
  CoreDesktop,
  CoreMobile,
  CoreTablet,
  CoreMshopsDesktop,
  CoreMshopsMobile,
  CoreMshopsTablet,
  MotorsDesktop,
  MotorsTablet,
  MotorsMobile,
  RealEstateDesktop,
  RealEstateTablet,
  RealEstateMobile,
  ServicesDesktop,
  ServicesTablet,
  ServicesMobile,
  HirableServicesDesktop,
  HirableServicesTablet,
  HirableServicesMobile,
} from '../nordic-pages/vip/ui-components/views';

export const VIP_VERTICALS = {
  CORE: 'core',
  MSHOPS: 'mshops',
  MOTORS: 'motors',
  REAL_STATE: 'real-estate',
  SERVICES: 'services',
  HIRABLE: 'hirable-services',
};

export const VIP_LAYOUTS_COMPONENTS = {
  [VIP_VERTICALS.CORE]: {
    mobile: CoreMobile,
    desktop: CoreDesktop,
    tablet: CoreTablet,
  },
  [VIP_VERTICALS.MSHOPS]: {
    mobile: CoreMshopsMobile,
    desktop: CoreMshopsDesktop,
    tablet: CoreMshopsTablet,
  },
  [VIP_VERTICALS.MOTORS]: {
    mobile: MotorsMobile,
    desktop: MotorsDesktop,
    tablet: MotorsTablet,
  },
  [VIP_VERTICALS.REAL_STATE]: {
    mobile: RealEstateMobile,
    desktop: RealEstateDesktop,
    tablet: RealEstateTablet,
  },
  [VIP_VERTICALS.SERVICES]: {
    mobile: ServicesMobile,
    desktop: ServicesDesktop,
    tablet: ServicesTablet,
  },
  [VIP_VERTICALS.HIRABLE]: {
    mobile: HirableServicesMobile,
    desktop: HirableServicesDesktop,
    tablet: HirableServicesTablet,
  },
};
